import boletaApi from "./boletaApi";

export const getPendingCompanies = async () => {
  try {
    return await boletaApi.get("/getPendingCompanies");
  } catch (error) {
    const { response } = error;
    return response;
  }
};
